import { render, staticRenderFns } from "./TSimpleTable.vue?vue&type=template&id=bb5846ca&scoped=true&"
import script from "./TSimpleTable.vue?vue&type=script&lang=js&"
export * from "./TSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./TSimpleTable.vue?vue&type=style&index=0&id=bb5846ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5846ca",
  null
  
)

export default component.exports